<template>
	<v-app class="web" dark>
		<v-navigation-drawer
			mini-variant
			:mini-variant-width="96"
			fixed
			app
			primary
			clipped
			elevation-10
			color="primary"
			dark
			v-model="drawer"
		>
			<v-list class="py-0">
				<v-list-item
					v-for="(item, i) in items"
					:key="i"
					:exact="item.title === 'Home'"
					@click="$inertia.visit(item.route)"
					:input-value="$route().current(item.active)"
					class="text-center px-1"
				>
					<v-list-item-content>
						<v-list-item-title>
							<v-icon size="30">{{ item.icon }}</v-icon>
						</v-list-item-title>
						<v-list-item-subtitle
							class="text-wrap"
							style="font-size: 12px"
						>
							{{ item.title }}
						</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>
		<!-- App Bar -->
		<v-app-bar
			fixed
			app
			:dark="true"
			color="primary"
			primary
			elevation="1"
			:elevate-on-scroll="false"
			clipped-right
			clipped-left
		>
			<v-app-bar-nav-icon class="ml-1" @click.stop="drawer = !drawer" />
			<a
				href="https://thaliashospitality.com"
				target="_blank"
				style="width: 40px"
				class="mr-2"
				><v-img
					:src="'/images/symbol.png'"
					width="40"
					height="40"
					contain
					small
				>
				</v-img
			></a>
			<v-toolbar-title>THALIAS SHOP</v-toolbar-title>

			<v-spacer></v-spacer>

			<OrdersPartial></OrdersPartial>
			<!-- <v-toolbar-items class="hidden-md-and-down">
				<template v-if="customer">
					<v-menu open-on-hover bottom offset-y>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								text
								v-bind="attrs"
								v-on="on"
								@click="$inertia.visit($route('profile.index'))"
							>
								<v-icon left>mdi-account</v-icon>
								{{ customer.display_name }}
								<v-icon right>mdi-menu-down</v-icon>
							</v-btn>
						</template>

						<v-list dense>
							<Link
								as="v-list-item"
								:href="$route('reservation.reservations.index')"
							>
								<v-list-item-action>
									<v-icon>mdi-calendar</v-icon>
								</v-list-item-action>
								<v-list-item-content>
									<v-list-item-title>{{
										$t("label.my_reservations")
									}}</v-list-item-title>
								</v-list-item-content>
							</Link>
							<Link
								as="v-list-item"
								:href="$route('shop.orders.index')"
							>
								<v-list-item-action>
									<v-icon>mdi-cart</v-icon>
								</v-list-item-action>
								<v-list-item-content>
									<v-list-item-title>{{
										$t("label.my_orders")
									}}</v-list-item-title>
								</v-list-item-content>
							</Link>
							<Link
								as="v-list-item"
								:href="$route('shop.addresses.index')"
							>
								<v-list-item-action>
									<v-icon>mdi-map-marker</v-icon>
								</v-list-item-action>
								<v-list-item-content>
									<v-list-item-title>{{
										$t("label.address")
									}}</v-list-item-title>
								</v-list-item-content>
							</Link>
							<v-divider></v-divider>
							<v-list-item @click="logout()">
								<v-list-item-icon
									><v-icon
										>mdi-logout</v-icon
									></v-list-item-icon
								>
								<v-list-item-title>{{
									$t("label.logout")
								}}</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
				</template>
				<template v-else>
					<v-btn text @click="$inertia.visit($route('auth.index'))">
						<v-icon left>mdi-login</v-icon>
						{{ $t("label.login") }}/{{ $t("label.register") }}
					</v-btn>
				</template>
			</v-toolbar-items> -->
			<v-badge
				:content="unreadNotificationsCount"
				:value="unreadNotificationsCount"
				color="red"
				overlap
			>
				<v-btn icon @click.stop="toggleNotificationDrawer()">
					<v-icon>mdi-bell-ring</v-icon>
				</v-btn>
			</v-badge>
		</v-app-bar>

		<!-- Main -->
		<v-main
			style="
				background-color: #141f35;
				background-repeat: repeat;
				background-size: contain;
				background-blend-mode: color-dodge;
			"
		>
			<app-head title="Home" />
			<app-flash-message></app-flash-message>
			<slot />
		</v-main>

		<v-navigation-drawer
			v-model="rightDrawer"
			right
			temporary
			fixed
			width="400px"
		>
			<app-notification-drawer
				@onClose="rightDrawer = false"
				ref="notifications"
				:route="$route('notifications.index')"
			></app-notification-drawer>
		</v-navigation-drawer>

		<!-- Footer -->
		<v-footer
			absolute
			inset
			app
			id="home-footer"
			color="black"
			dark
			min-height="72"
			clipped-right
			v-if="false"
		>
			<v-container>
				<v-row>
					<v-col cols="12" md="6">
						<div
							class="
								d-flex
								flex-wrap
								justify-md-start justify-center justify-md-none
							"
						>
							<template v-for="(s, i) in social">
								<a
									:key="s"
									class="white--text pa-1 pa-md-0"
									href="#"
									v-text="s"
								/>

								<v-responsive
									v-if="i < social.length - 1"
									:key="`divider-${s}`"
									class="mx-4 shrink hidden-sm-and-down"
									max-height="24"
								>
									<v-divider vertical />
								</v-responsive>
							</template>
						</div>
					</v-col>

					<v-col class="text-center text-md-right" cols="12" md="6">
						Copyright &copy; {{ new Date().getFullYear() }} Vuetify,
						LLC
					</v-col>
				</v-row>
			</v-container>
		</v-footer>
	</v-app>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue";
import OrdersPartial from "./partials/web/orders.vue";
export default {
	components: {
		Link,
		OrdersPartial,
	},
	data() {
		return {
			drawer: false,
			rightDrawer: false,
			logo: this.$page.props.assets.logo,
			social: ["Facebook", "Twitter", "Instagram", "Linkedin"],
			items: [
				{
					title: this.$t("label.home"),
					route: this.$route("index"),
					active: "index",
					icon: "mdi-home",
				},
				{
					title: this.$t("title.reservation"),
					route: this.$route("reservation.tenants"),
					active: "reservation.*",
					icon: "mdi-calendar",
				},
				{
					title: this.$t("title.discover"),
					route: this.$route("discover.map"),
					active: "discover.*",
					icon: "mdi-map",
				},
				{
					title: this.$t("title.wallet"),
					route: this.$route("wallet.index"),
					active: "wallet.*",
					icon: "mdi-wallet",
				},
				{
					title: this.$t("title.membership"),
					route: this.$route("membership.index"),
					active: "membership.*",
					icon: "mdi-cash",
				},
				{
					title: this.$t("title.book_an_event"),
					icon: "mdi-wallet-giftcard",
					route: this.$route("event.index"),
					active: "event.*",
				},
				{
					title: this.$t("title.place_an_order"),
					route: this.$route("shop.index"),
					active: "shop.*",
					icon: "mdi-store",
				},
			],
			shopType: this.$page.props.shop.type,
		};
	},
	computed: {
		customer() {
			return this.$page.props.auth.customer;
		},

		unreadNotificationsCount() {
			return this.$page.props.auth.unreadNotificationsCount;
		},

		overlayBackground() {
			return "url('" + this.$page.props.assets.overlay_background + "')";
		},
	},

	methods: {
		logout() {
			this.$inertia.delete(this.$route("auth.logout"));
		},

		async toggleNotificationDrawer() {
			this.rightDrawer = !this.rightDrawer;
			if (this.rightDrawer) {
				await this.$refs.notifications.getItems();
			}
		},
	},
};
</script>

